import { SDUIComponentRenderer } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import {
  SDUISectionInstanceRendererProps,
  SectionLoggingEventParams,
} from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUIRotatingSectionComponentRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/RotatingSection/SDUIRotatingSectionComponentRenderer";
import React from "react";

export const SDUIRotatingSectionRenderer: React.FC<
  SDUISectionInstanceRendererProps
> = ({ section, componentRenderers, sectionLoggingData, loadTimingRef }) => {
  const rotatingSection = section.rotating_section;

  if (!rotatingSection) {
    return null;
  }

  return (
    <div className="grid min-h-[36px]">
      {rotatingSection.components.map((component) => (
        <div
          key={component.id}
          className="invisible col-start-1 row-start-1 h-fit w-full"
        >
          <SDUIComponentRenderer
            isPrimaryContent
            key={component.id}
            // We don't want to have any logging in this section
            // Since it isn't shown to the user
            component={{
              ...component,
              logging_data: undefined,
            }}
            componentRenderers={componentRenderers}
            sectionLoggingParams={SectionLoggingEventParams.build()}
          />
        </div>
      ))}
      <div
        data-test-id="visible-rotating-section-component-renderer"
        className="col-start-1 row-start-1"
      >
        <SDUIRotatingSectionComponentRenderer
          section={section}
          componentRenderers={componentRenderers}
          loadTimingRef={loadTimingRef}
          sectionLoggingData={sectionLoggingData}
        />
      </div>
    </div>
  );
};
